/**
 *
 * PreviewImage
 *
 */

import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { compose } from "redux"
import { Spin } from "antd"
import { loadTexts } from "../../../../../utils/i18n"

const RenderImage = ({ images, title, changeState, state }) => {
  const intlExportable = loadTexts("reports_exportables")
  return (
    <Fragment>
      <div className="title">
        <b>{intlExportable.template}: </b> {title}
        <p>{intlExportable.previewImageText}</p>
      </div>
      {!state && (
        <div className="loadingSpin" onLoad={changeState}>
          <Spin size="large" />
        </div>
      )}
      {images.map((image, index) => (
        <img
          key={`img--${index}`}
          src={image}
          onLoad={changeState}
          style={!state ? { display: "none" } : {}}
        />
      ))}
    </Fragment>
  )
}

export class PreviewImage extends React.Component {
  intlExportable = loadTexts("reports_exportables")
  constructor(props) {
    super(props)
    this.state = {
      isLoadingImages: false,
      templateImages: {
        organization: {
          table: [
            "https://app-manduhr-prd.s3.amazonaws.com/img/default/report/preview/org-tabla1.png",
            "https://app-manduhr-prd.s3.amazonaws.com/img/default/report/preview/org-tabla2.png",
          ],
          presentation: [
            "https://app-manduhr-prd.s3.amazonaws.com/img/default/report/preview/org-presentacion1.png",
            "https://app-manduhr-prd.s3.amazonaws.com/img/default/report/preview/org-presentacion2.png",
          ],
        },
        division: {
          table: [
            "https://app-manduhr-prd.s3.amazonaws.com/img/default/report/preview/div-tabla1.png ",
            "https://app-manduhr-prd.s3.amazonaws.com/img/default/report/preview/div-tabla2.png",
          ],
          presentation: [
            "https://app-manduhr-prd.s3.amazonaws.com/img/default/report/preview/div-presentacion1.png",
            "https://app-manduhr-prd.s3.amazonaws.com/img/default/report/preview/div-presentacion2.png",
          ],
        },
        leader: {
          table: [
            "https://app-manduhr-prd.s3.amazonaws.com/img/default/report/preview/leader-tabla1.png ",
            "https://app-manduhr-prd.s3.amazonaws.com/img/default/report/preview/leader-tabla2.png",
          ],
          presentation: [
            "https://app-manduhr-prd.s3.amazonaws.com/img/default/report/preview/div-presentacion1.png",
            "https://app-manduhr-prd.s3.amazonaws.com/img/default/report/preview/div-presentacion2.png",
          ],
        },
      },
    }
  }

  render() {
    const { templateImages, isLoadingImages } = this.state
    const { exportTemplate, exportScopeSelect, measure } = this.props

    const divisionOrTeam =
      measure.id_survey_type === 2
        ? templateImages.leader
        : templateImages.division
    const exportMeditionLeader = measure.id_survey_type === 2

    if (exportTemplate === "table") {
      if (exportScopeSelect === "all" && !exportMeditionLeader) {
        return (
          <RenderImage
            title={this.intlExportable.table}
            images={templateImages.organization.table}
            changeState={() => this.setState({ isLoadingImages: true })}
            state={isLoadingImages}
          />
        )
      }
      if (isNaN(parseInt(exportScopeSelect, 10))) {
        return (
          <RenderImage
            title={this.intlExportable.table}
            images={divisionOrTeam.table}
            changeState={() => this.setState({ isLoadingImages: true })}
            state={isLoadingImages}
          />
        )
      }
    } else if (exportTemplate === "presentation") {
      if (exportScopeSelect === "all") {
        return (
          <RenderImage
            title={this.intlExportable.presentation}
            images={templateImages.organization.presentation}
            changeState={() => this.setState({ isLoadingImages: true })}
            state={isLoadingImages}
          />
        )
      }
      if (isNaN(parseInt(exportScopeSelect, 10))) {
        return (
          <RenderImage
            title={this.intlExportable.presentation}
            images={divisionOrTeam.presentation}
            changeState={() => this.setState({ isLoadingImages: true })}
            state={isLoadingImages}
          />
        )
      }
    }
  }
}

PreviewImage.propTypes = { dispatch: PropTypes.func.isRequired }

function mapDispatchToProps(dispatch) {
  return { dispatch }
}

const withConnect = connect(null, mapDispatchToProps)

export default compose(withConnect)(PreviewImage)
